import axios from 'axios';
import Cookies from 'js-cookie';

const setupAxiosInterceptors = (navigate) => {
  // Request interceptor
  axios.interceptors.request.use(
    (config) => {
      const token = Cookies.get('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        
        const refreshTokenValue = Cookies.get('refreshToken');
        if (!refreshTokenValue) {
          clearAuthData();
          navigate("/login");
          return Promise.reject(error);
        }
          try {
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/users/refresh`, 
              {refreshToken: refreshTokenValue}
            );
            
            if (res.status === 200) {
              const { accessToken } = res.data;
              const newTokenTimestamp = new Date().getTime();
              
              Cookies.set('token', accessToken, { expires: 1, secure: true, sameSite: 'strict' });
              Cookies.set('tokenTimestamp', newTokenTimestamp, { expires: 1, secure: true, sameSite: 'strict' });
              
              originalRequest.headers.Authorization = `Bearer ${accessToken}`;
              return axios(originalRequest);
            }
          
          } catch (refreshError) {
            // Clear all auth data and redirect to login
            clearAuthData();
            navigate('/login');
            return Promise.reject(error);
          }
        }
      
      return Promise.reject(error);
    }
  );
};

const clearAuthData = () => {
  Cookies.remove('token');
  Cookies.remove('refreshToken');
  Cookies.remove('tokenTimestamp');
  Cookies.remove('role');
  Cookies.remove('userName');
  Cookies.remove('email');
};

export { setupAxiosInterceptors };